import ServerBaseError from './ServerBaseError';

export default class ServerAccessDeniedError extends ServerBaseError {
  constructor(message = 'No access', showErrorPage = false) {
    super(message, showErrorPage);
  }
}
